import { addStringBeforeFileNameExtension } from "@therms/web-js";
// src/modules/Files/utils/get-therms-image-small-url.ts
function getTHERMSImageSmallUrl(url) {
	if (!url) return "";
	if (!url.includes("s3")) return url;
	if (url.includes("therms-files")) return `${url}.small`;
	return addStringBeforeFileNameExtension(url, "_small");
}
export { getTHERMSImageSmallUrl };

//# sourceMappingURL=get-therms-image-small-url.js.map